export const HYPERLIQUID_API_URL = "https://api.hyperliquid.xyz";

const JSON_HEADERS = {
  "Content-Type": "application/json",
} as const;

type Json = Record<string, unknown>;

async function postToHyperliquid<T>(path: string, body: Json): Promise<T> {
  const response = await fetch(`${HYPERLIQUID_API_URL}${path}`, {
    method: "POST",
    headers: JSON_HEADERS,
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorText = await response.text();
    const message = errorText || response.statusText || "Hyperliquid request failed";
    throw new Error(message);
  }

  return (await response.json()) as T;
}

export function postHyperliquidInfo<T>(body: Json) {
  return postToHyperliquid<T>("/info", body);
}

export function postHyperliquidExchange<T>(body: Json) {
  return postToHyperliquid<T>("/exchange", body);
}
